/// <amd-module name="Artifacts/Cargo/commands/Delete" />
import { CargoActions } from "Artifacts/Cargo/redux";
import { getDeleteCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createDeleteCommand = getDeleteCommandCreator(CargoActions.softDelete);
